<template>
  <div>
    <base-header class="pb-5">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="showFilters=!showFilters">Filters</base-button>
          <router-link :to="{ name: 'newMaintenance' }" class="btn btn-neutral btn-sm">New</router-link>
        </b-col>
      </b-row>
      <b-row v-if="showFilters">
        <b-col cols="2">
          <label class="form-control-label" for="motorbike">Motorbike</label>
            <div class="form-group">
              <select class="form-control" v-model="filters.motorbike" @change="onChangeMotorbike">
                <option v-bind:value="null">Any</option>
                <option v-for="motorbike in motorbikes" v-bind:key="motorbike.id" v-bind:value="motorbike.id">{{motorbike._name}}</option>
              </select>
            </div>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <b-row>
        <b-col>
          <maintenances-table/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import MaintenancesTable from "../Tables/MaintenancesTable";
  import { mapActions, mapGetters } from 'vuex';


  export default {
    name: 'maintenances-page',
    components: {
      RouteBreadCrumb,
      MaintenancesTable
    },
    data() {
      return {
        showFilters: true,
        filters: {
          motorbike: null
        }
      }
    },
    computed: {
      ...mapGetters({
        motorbikes: 'motorbikes/motorbikes'
      }),
      computedFilters() {
        return {
          motorbike: this.filters.motorbike
        }
      }
    },
    async mounted() {
      await this.fetchMotorbikes()
      if (this.$route.query.motorbike) {
        this.filters.motorbike = this.$route.query.motorbike
      }
      await this.fetchItems(this.computedFilters)
    },
    methods: {
      ...mapActions({
        fetchMotorbikes: 'motorbikes/fetch',
        fetchItems: 'maintenances/fetch'
      }),
      onChangeMotorbike () {
        this.fetchItems(this.computedFilters)
      }
    }
  };
</script>
